import { createSlice } from '@reduxjs/toolkit'

export const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    title: 'Teknikforce',
    summary: 'Uses cutting-edge technology to develop and deliver innovative software applications and websites.',
    files: [null, null],
    fontFamily: 'Arial, sans-serif',
    cardColor: '#ffffff',
    titleColor: '#000000',
    summaryColor: '#000000',
    buttonBackgroundColor: '#5e59fe',
    buttonTextColor: '#ffffff'
  },
  reducers: {
    setMenuField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setImage(state, action) {
      state.files[0] = action.payload
    },
    setPDF(state, action) {
      state.files[1] = action.payload
    },
    initializeMenu(state, action) {
      state.title = 'Teknikforce'
      state.summary = 'Uses cutting-edge technology to develop and deliver innovative software applications and websites.'
      state.files = [null, null]
      state.fontFamily = 'Arial, sans-serif'
      state.cardColor = '#ffffff'
      state.titleColor = '#000000'
      state.summaryColor = '#000000'
      state.buttonBackgroundColor = '#5e59fe'
      state.buttonTextColor = '#ffffff'
    }
  }
})

export const {
  setMenuField,
  setImage,
  setPDF,
  initializeMenu
} = menuSlice.actions
export default menuSlice.reducer